// /src/components/LoginForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
/* global axios */
import api from '../services/apiService';

const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // API-Aufruf über die Axios-Instanz; baseURL wird automatisch verwendet
      const response = await api.post('/auth/login', { username, password });
      const data = response.data;
      
      if (data.accessToken) {
        // Token in der Session speichern
        sessionStorage.setItem('accessToken', data.accessToken);
        window.dispatchEvent(new Event('auth:login'));

         // Minimal: zusätzlich für openDamageHtml ablegen & Axios-Header setzen
       localStorage.setItem('token', data.accessToken);
       api.defaults.headers.common.Authorization = `Bearer ${data.accessToken}`;

        alert('Login erfolgreich!');
        // Weiterleiten – hier relative URL nutzen (z. B. über einen Router oder direkt)
        sessionStorage.setItem('calendarShowToday', 'true');
        navigate('/calendar');
      } else {
        alert('Login fehlgeschlagen: Kein Token erhalten.');
      }
    } catch (error) {
      console.error('Login fehlgeschlagen:', error);
    }
  };

  return (
    <div style={{ maxWidth: '300px', margin: 'auto' }}>
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="loginUsername">Benutzername:</label>
          <input
            type="text"
            id="loginUsername"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="loginPassword">Passwort:</label>
          <input
            type="password"
            id="loginPassword"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default LoginForm;
